import React, { useEffect, useState } from "react";
import styles from "../styles/Partner.module.css";
import Header from "../components/Header";
import pic from "../assets/partner.png";
import payment from "../assets/partner.png";
import view from "../assets/partners.png";
import AhaduBankLogo from "../assets/ahadu.jpeg";
import AwashBankLogo from "../assets/awash.png";
import EthSwitchLogo from "../assets/etswitch.jpeg";
import CoopBankLogo from "../assets/coop.png";
import ZemZemBankLogo from "../assets/zemen.png";
import BunnaBankLogo from "../assets/buna.png";
import Footer from "../components/Footer";
import map from "../assets/map.png";
import one from "../assets/carbon_sales-ops.svg";
import two from "../assets/oui_integration-general.svg";
import three from "../assets/proicons_bank (3).svg";
import four from "../assets/weui_shop-outlined.svg";
import five from "../assets/mdi_partnership-outline.svg";
import EnatBankLogo from "../assets/enat.jpeg";
import telebirr from "../assets/telebirr.png";
import hibretLogo from "../assets/hibret.png";
import { Link, useLocation } from "react-router-dom";
import abay from "../assets/abay.jpeg";
import nib from "../assets/nib.jpeg";
import cbeLogo from "../assets/cbe.png";
import brehan from "../assets/brehan.png";
import enatLogo from "../assets/enat.jpeg";
import addis from "../assets/addis.jpeg";
import coop from "../assets/coop.png";
import visa from "../assets/visa1.png";
import master from "../assets/master.png";
import absiniyaLogo from "../assets/absiniya.png";
import zemenLogo from "../assets/zemen.png";
import dashen from "../assets/dashen.png";
import tsehay from "../assets/tsehay.jpeg";
import wegagen from "../assets/wegagen.png";
import sinqee from "../assets/sinqe.png";
import oromia from "../assets/oromia.png";
import yaya from "../assets/yaya.svg";

const Partner = () => {
  const [activeCategory, setActiveCategory] = useState("financial");

  const partnerLists = {
    financial: [
      { src: hibretLogo, alt: "Hibret Bank" },
      { src: telebirr, alt: "telebirr" },
      { src: abay, alt: "abay Switch" },
      { src: AwashBankLogo, alt: "awash Bank" },
      { src: AhaduBankLogo, alt: "ahadu Bank" },
      { src: BunnaBankLogo, alt: "Bunna Bank" },
      { src: nib, alt: "nib Bank", size: "xlarge" },
      { src: cbeLogo, alt: "cbe Bank", size: "xxlarge" },
      { src: brehan, alt: "brehan bank", size: "small" },
      { src: enatLogo, alt: "enat Bank", size:"xxsmall" },
      { src: addis, alt: "addis Bank" },
      { src: coop, alt: "coop Switch", size:"xxxsmall" },
      { src: master, alt: "master Bank", size: "xxxsmall" },
      { src: visa, alt: "visa Bank" },
      { src: absiniyaLogo, alt: "abisinia Bank" },
      { src: zemenLogo, alt: "zemen Bank"},
      { src: dashen, alt: "dashen Bank" },
      { src: tsehay, alt: "tsehay" },
      { src: wegagen, alt: "wegagen" },
      { src: sinqee, alt: "sinqe", size:"xxxsmall" },
      { src: oromia, alt: "oromia" },
      { src: yaya, alt: "yaya" },
    ],
  };

  const ScrollingPartnerRow = ({ partners }) => {
    const scrollingPartners = [...partners, ...partners];
    
    return (
      <div className={styles.scrollingRowContainer}>
        <div className={styles.scrollingRow}>
          {scrollingPartners.map((partner, index) => (
            <div key={`${index}-${partner.alt}`} className={styles.partnerLogo}>
              <img 
                src={partner.src} 
                alt={partner.alt} 
                className={`${styles.partnerImage} ${
                  partner.size ? styles[partner.size] : styles.medium
                }`}
              />
            </div>
          ))}
        </div>
      </div>
    );
  };

  const salesFocusedText = [
    "Reseller",
    "Value Added Reseller(VAR)",
    "Service Delivery Partners",
    "Trainers",
    "Strategic Partners/Alliance",
    "Distributors",
    "Deal Facilitator",
  ];

  const technologyFocusedText = [
    "System Intagrator (SI)",
    "Managed Service Provides(MSP)",
    "ICT Consultant",
    "Independent Software Vendors/Tech Partners",
    "Original Equipment Manufacturer (OEM)",
    "Value Added Reseller(VAR)",
    "Service Delivery Partners",
  ];

  const [activeButton, setActiveButton] = useState("sales");

  const renderSideText = () => {
    const contentToRender = activeButton === "sales" 
      ? salesFocusedText 
      : technologyFocusedText;

    return contentToRender.map((item, index) => (
      <p
        key={index}
        style={{
          textAlign: "left",
          marginLeft: "20px",
          fontSize: "1.2em",
        }}
      >
        <span className={styles.icon}>✦</span>
        {item}
      </p>
    ));
  };

  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div className={styles.container}>
      <Header />
      <div className={styles.empoweringSection}>
        <div className={styles.hero}>
          <div className={styles.heroContent}>
            <p className={styles.msmesLabel}>PARTNERSHIP</p>
            <h2 className={styles.heroTitle}>
              Partner With Arifpay Let's Innovate and Create
              New Possibilities For Businesses In Ethiopia
            </h2>
            <Link to="/become-a-partner">
              <button className={styles.contactButton}>Join Us →</button>
            </Link>
          </div>
          <div>
            <div className={styles.heroImage}>
              <img
                style={{
                  borderRadius: "20px",
                  width: "500px",
                  height: "300px",
                  marginRight: "100px",
                }}
                src={pic}
                alt="Payment terminal in a shop"
              />
            </div>
          </div>
        </div>

        <hr
          className={styles.separate}
          style={{
            border: "none",
            borderTop: "1px solid #ccc",
            margin: "40px 80px",
          }}
        />
      </div>
      
      <div className={styles.helpingSection}>
        <div className={styles.helpingText}>
          <p style={{ color: "green", marginTop: "0" }}>
            OUR STRATEGIES
          </p>
          <h2 className={styles.helpingTitle}>
            Grow Your Business Alongside ours
          </h2>
          <p
            style={{
              color: "light gray",
              textAlign: "center",
              // fontSize: "1.4em",
            }}
          >
            Our Partner Program has been thoughtfully crafted with your success
            as our top priority.  <br /> We are committed to assisting you in providing
            enhanced and adaptable payment solutions to your valued customers.
          </p>
          <Link to="/partner2">
            <button className={styles.primaryButton}>Become a partner →</button>
          </Link>
        </div>
      </div>

      <section
        className={styles.dev}
        style={{ display: "flex", alignItems: "center", gap: "2rem" }}
      >
        <div
          className={styles.viewText}
          style={{ flex: 1, marginLeft: "200px" }}
        >
          <h3 style={{ fontSize: "1.6em" }}>
            <span className={styles.icon}>✦</span>Simplicity
          </h3>
          <p style={{ color: "black", fontSize: "1.3em" }}>
            Secure & Reliable sets clear, measurable goals for{" "}
            <span className={styles.breakMobile}></span>success
          </p>

            <h3 style={{ fontSize: "1.6em" }}>
              <span className={styles.icon}>✦</span>Flexibility
            </h3>
            <p style={{ color: "gblackray", fontSize: "1.3em" }}>
              We recognize and accommodate local
              <span className={styles.breakMobile}></span> requirements,as well
              as understand the diverse
              <span className={styles.breakMobile}></span> partner routes to
              market.
            </p>
          

          <h3 style={{ fontSize: "1.6em" }}>
            <span className={styles.icon}>✦</span>Innovation
          </h3>
          <p style={{ color: "black", fontSize: "1.3em" }}>
            We collaborate closely with you to co-innovate and creat distinctive
            digital<br/> payment solutions tailored
            <span className={styles.breakMobile}></span> to your clients' need
          </p>
        </div>

        <div
          className={styles.solutionImage}
          style={{
            flexShrink: 0,
            maxWidth: "400px",
            marginTop: "80px",
            marginRight: "200px",
            position: "relative",
            display: "inline-block",
          }}
        >
          <img
            src={payment}
            alt="feature payment"
            style={{
              width: "340%",
              marginRight: "200px",
              height: "auto",
              display: "block",
              borderRadius: "35px",
            }}
          />
        </div>
      </section>

      <section className={styles.partnerStatsSection}>
        <div className={styles.statsContainer}>
          <div className={styles.singleItemRow}>
            <div className={styles.statCard}>
              <img src={one} alt="value" />
              <h3 className={styles.statNumber}>19</h3>
              <p className={styles.statLabel}>
                Value-Added
                <br />
                Reseller
              </p>
            </div>
          </div>

          <div className={styles.twoItemRow}>
            <div className={styles.statCard}>
              <img src={two} alt="value" />
              <h3 className={styles.statNumber}>14</h3>
              <p className={styles.statLabel}>System Integrator</p>
            </div>
            <div className={styles.statCard}>
              <img src={three} alt="value" />
              <h3 className={styles.statNumber}>32</h3>
              <p className={styles.statLabel}>Acquiring Bank</p>
            </div>
          </div>

          <div className={styles.twoItemRow}>
            <div className={styles.statCard}>
              <img src={four} alt="value" />
              <h3 className={styles.statNumber}>25</h3>
              <p className={styles.statLabel}>Resellers</p>
            </div>
            <div className={styles.statCard}>
              <img src={five} alt="value" />
              <h3 className={styles.statNumber}>20</h3>
              <p className={styles.statLabel}>Strategic Partner</p>
            </div>
          </div>
        </div>
      </section>

      <section className={styles.buttonSection}>
        <div className={styles.buttonContainer}>
          <div className={styles.buttonText}>
            <h2 className={styles.buttonHeader}>
              Select The Right Partnership
            </h2>
            <p className={styles.buttonParagraph}>
              Partner with us to access our world-class payment ecosystem, gain
              expertise and ensure the success of our mutual customers.
            </p>
          </div>
          <div className={styles.buttonAndText}>
            <div className={styles.buttonGroup}>
              <button
                style={{
                  backgroundColor:
                    activeButton === "sales"
                      ? "var(--primary-green)"
                      : "transparent",
                  color: activeButton === "sales" ? "white" : "inherit",
                  padding: "10px 20px",
                  border: "none",
                  borderRadius: "12px",
                  fontSize: "1.4em",
                  cursor: "pointer",
                }}
                onClick={() => setActiveButton("sales")}
              >
                Sales-focused <span className={styles.buttonIcon}>→</span>
              </button>
              <button
                style={{
                  backgroundColor:
                    activeButton === "technology"
                      ? "var(--primary-green)"
                      : "transparent",
                  color: activeButton === "technology" ? "white" : "inherit",
                  padding: "10px 20px",
                  borderRadius: "12px",
                  border: "none",
                  fontSize: "1.4em",
                  cursor: "pointer",
                }}
                onClick={() => setActiveButton("technology")}
              >
                Technology-focused <span className={styles.buttonIcon}>→</span>
              </button>
            </div>
            <div className={styles.buttonSideText}>
              {renderSideText()}
              <Link to="/partner2">
                <button
                  className={styles.Partner}
                  style={{
                    backgroundColor: "var(--primary-green)",
                    border: "none",
                    padding: "10px 20px",
                    borderRadius: "10px",
                    fontSize: "1em",
                    marginTop: "20px",
                  }}
                >
                  Become a partner →
                </button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className={styles.howItWorksSection}>
        <p style={{ fontSize: "1em" }} className={styles.subtitle}>
          TAKE YOUR FIRST STEP AS A PARTNER
        </p>
        <h2 style={{ fontSize: "2.4em" }} className={styles.title}>
          How it works?
        </h2>

        <div className={styles.stepsContainer}>
          <div className={styles.stepCard}>
            <hr
              className={styles.separator}
              style={{
                border: "none",
                borderTop: "1px solid #ccc",
                margin: "40px 80px",
                marginTop: "100px",
              }}
            />
            <p style={{ fontSize: "1em" }} className={styles.stepNumber}>
              STEP 1
            </p>
            <h3 style={{ fontSize: "1.6em" }} className={styles.stepTitle}>
              Contact Us
            </h3>
            <p style={{ fontSize: "1em" }} className={styles.stepDescription}>
              Vist our website or email our partnership team
              to express your interest. Let's revolutionize
              digital payments together.
            </p>
          </div>

          <div className={styles.stepCard}>
            <hr
              className={styles.separator}
              style={{
                border: "none",
                borderTop: "1px solid #ccc",
                margin: "40px 80px",
                marginTop: "100px",
              }}
            />

            <p style={{ fontSize: "1em" }} className={styles.stepNumber}>
              STEP 2
            </p>
            <h3 style={{ fontSize: "1.6em" }} className={styles.stepTitle}>
              Complete The Application
            </h3>
            <p style={{ fontSize: "1em" }} className={styles.stepDescription}>
              Once you've expressed your interest, We will
              furnish you with an application form to
              complete. The application will request details
              about your company, business model.
            </p>
          </div>
             <div className={styles.stepCard}>
            <hr
              className={styles.separator}
              style={{
                border: "none",
                borderTop: "1px solid #ccc",
                margin: "40px 80px",
                marginTop: "100px",
              }}
            />

            <p style={{ fontSize: "1em" }} className={styles.stepNumber}>
              STEP 3
            </p>
            <h3 style={{ fontSize: "1.6em" }} className={styles.stepTitle}>
              Review and Sign Agreement
            </h3>
            <p style={{ fontSize: "1em" }} className={styles.stepDescription}>
              After submitting your application, We will review it and contact you to discuss the partnership further. If everything looks good, they will provide you with an agreement to review.
            </p>
          </div>

          {/* <div className={styles.stepCard} >
            <hr
              className={styles.separator}
              style={{
                border: "none",
                borderTop: "1px solid #ccc",
                margin: "40px 80px",
                marginTop: "100px",
              }}
            />

            <p style={{ fontSize: "1em" }} className={styles.stepNumber}>
              STEP 3
            </p>
            <h3 style={{ fontSize: "1.6em" }} className={styles.stepTitle}>
              Review and Sign Agreement
            </h3>
            <p style={{ fontSize: "1em" }} className={styles.stepDescription}>
              After submitting your application, We will review
              it and contact you to discuss the partnership
              further. If everything looks good, they will
              provide you with an agreement to review.
            </p>
          </div> */}

        </div>

        <Link to="/partner2">
          <button className={styles.primaryButton}>Become a partner →</button>
        </Link>
      </section>

      <div className={styles.partnersSection}>
        <h2 style={{fontSize:'28px', fontWeight:'bold', marginLeft:"40px", color:'green'}}>
          Our Financial Partners
        </h2>

        <ScrollingPartnerRow partners={partnerLists[activeCategory]} />

        <div className={styles.newImage}>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3940.702791019915!2d38.781710610735324!3d8.99947168941288!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x164b85ba309a753d%3A0x8fe6207c84f3c29d!2sArifpay%20financial%20technologies%20S.C!5e0!3m2!1sen!2set!4v1748701360868!5m2!1sen!2set"
            width="100%"
            height="450"
            style={{
              border: 0,
              allowFullScreen: "",
              loading: "lazy",
              referrerPolicy: "no-referrer-when-downgrade",
            }}
            title="Arifpay Location"
          ></iframe>
        </div>
      </div>

      <section className={styles.bottom}>
        <div
          style={{
            backgroundColor: "var(--primary-green)",
            color: "#fff",
            padding: "20px 30px",
            borderRadius: "35px",
            // margin: "40px 70px 40px 50px",
          }}
        >
          <div
            style={{
              maxWidth: "1200px",
              margin: "0 auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
            }}
          >
            <div style={{ flex: "1", maxWidth: "550px", marginBottom: "30px" }}>
              <h2
                style={{
                  fontSize: "28px",
                  marginBottom: "15px",
                  color: "white",
                }}
              >
                Let's Partner to Grow Your Business!
              </h2>
              <p style={{ fontSize: "0.9em" }}>
                <span style={{ color: "white", fontSize: "0.6em" }}>✦</span>{" "}
                Apply to Become a Partner
              </p>
              <Link to="/become-a-partner">
                <button
                  style={{
                    backgroundColor: "#fff",
                    color: "green",
                    border: "none",
                    padding: "15px 30px",
                    borderRadius: "5px",
                    fontSize: "16px",
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                >
                  Apply Now →
                </button>
              </Link>
            </div>

            <div className={styles.bottomImage}
              style={{ flex: "1", display: "flex", justifyContent: "flex-end" }}
            >
              <img
                src={view}
                alt="Payment Terminal"
                style={{
                  width: "100%",
                  maxWidth: "450px",
                  height: "auto",
                  objectFit: "cover",
                  borderRadius: "25px",
                  border: "5px solid green",
                }}
              />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Partner;